import Courses from './Courses';
import type { CourseItemType } from '../../types';
import './index.scss';

export default ({ courses, id }
  :{ courses: CourseItemType[]; id: string; }): JSX.Element => {
  const coursesProps = { courses, id };

  return <Courses { ...coursesProps } />;
};
